import React from "react";
import { Label, IInputGroupProps, Classes } from "@blueprintjs/core";
import { Colors } from "../../Resources";
import { FunctionType } from "../../redux/reducer_types";
import classnames from "classnames";

declare type InputTypes =
    | "button"
    | "checkbox"
    | "color"
    | "date"
    | "datetime-local"
    | "email"
    | "file"
    | "hidden"
    | "image"
    | "month"
    | "number"
    | "password"
    | "radio"
    | "range"
    | "reset"
    | "search"
    | "submit"
    | "tel"
    | "text"
    | "time"
    | "url"
    | "week";

declare interface AppInputProps extends IInputGroupProps {
    label?: string;
    required?: boolean;
    onPressReturn?: FunctionType;
    placeholder?: string;
    maxLength?: number;
    value?: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    style?: React.CSSProperties;
    type?: InputTypes;
}

const AppInput: React.FC<AppInputProps> = ({
    label,
    required,
    placeholder,
    onPressReturn,
    className,
    ...rest
}) => {
    const renderInput = () => {
        return (
            <input
                className={classnames(Classes.INPUT, className)}
                placeholder={
                    placeholder
                        ? `${placeholder}${required && !label ? " *" : ""}`
                        : ""
                }
                onKeyDown={(event) => {
                    if (event.keyCode === 13) {
                        event.preventDefault();
                        if (onPressReturn) onPressReturn();
                    }
                }}
                {...rest}
            />
        );
    };

    if (label)
        return (
            <Label>
                {label}
                {required ? (
                    <span style={{ color: Colors.redMain }}> *</span>
                ) : (
                    ""
                )}
                <div style={{ height: 6 }} />
                {renderInput()}
            </Label>
        );
    else return renderInput();
};

AppInput.defaultProps = {
    onPressReturn: () => {},
    className: "",
};

export default AppInput;
